import { API } from "aws-amplify";
import { API_NAME } from "../common/constants";

/**
 * お知らせ単体取得APIコール
 * @param data
 * @returns
 */
export const getNewsId = async (newsId: number) => {
  const path = `/news/${encodeURIComponent(String(newsId))}`;
  const params = {};
  let result: any;
  await API.get(API_NAME, path, params)
    .then((response) => {
      result = response;
    })
    .catch((e) => {
      console.error(e);
      result = e.response.data;
    });
  return result;
};
